// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da
import Cookie from '~/common/cookie'
import { Auth } from 'aws-amplify'
import { logoutImpersonator } from '~/common/auth'

import {
  SESSION_LOGOUT,
} from './constants';

export function logout() {
  return {
    type: SESSION_LOGOUT,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case SESSION_LOGOUT:
      Cookie.remove('__naluri__')
      logoutImpersonator();
      Auth.signOut({ global: true })

      return {
        ...state,
        authenticated: null
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/session/redux/logout.js